import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Menu from '../components/menu';
import Footer from '../components/footer';
import api from '../config/axios';

const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [searchParams] = useSearchParams(); // Pour récupérer le token depuis l'URL
  const navigate = useNavigate();  

const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setErrorMessage('Les mots de passe ne correspondent pas.');
      return;
    }

    const token = searchParams.get('token');
    if (!token) {
      setErrorMessage('Le lien est invalide ou a expiré.');
      return;
    }

    try {
      await api.post('/auth/reset-password', { token, password });
      setMessage('Votre mot de passe a été réinitialisé avec succès.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || 'Une erreur est survenue');
      setMessage('');
    }
  };

  return (
    <div>
      <Menu />
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
          <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">Réinitialiser votre mot de passe</h2>
          {message && (
            <div className="mb-4 text-sm text-green-500 text-center">
              {message}
            </div>
          )}
          {errorMessage && (
            <div className="mb-4 text-sm text-red-500 text-center">
              {errorMessage}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1" htmlFor="password">
                Nouveau mot de passe
              </label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Entrez votre nouveau mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1" htmlFor="confirmPassword">
                Confirmez votre mot de passe
              </label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirmez votre nouveau mot de passe"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition duration-300"
            >
              Réinitialiser le mot de passe
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
